export function getAOCategories(types) {
  let a = [];
  if (!types) {
    return [];
  }
  types.forEach((item) => {
    item.Categories.forEach(({ CategoryName }) => a.push(CategoryName));
  });
  return a;
}

export function isTrue(b) {
  return b === 'true' || b === true;
}

export function isFalse(b) {
  return b === 'false' || b === false || !b;
}
